import React from "react";

interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onChange,
  className = "",
}) => {
  return (
    <div
      className={`p-1.5 px-2 bg-[#EBE4FF] border-[#3B1280] rounded-pill inline-flex items-center gap-1 shadow-inner ${className}`}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              flex items-center gap-2 md:px-6 px-4 py-1 rounded-pill transition-all duration-300
              ${
                isActive
                  ? "bg-secondary text-white shadow-lg scale-[1.02]"
                  : "text-black hover:bg-primary/5"
              }
            `}
          >
            {tab.icon && (
              <span
                className={`text-[16px] ${
                  isActive ? "text-white" : "text-black"
                }`}
              >
                {tab.icon}
              </span>
            )}
            <span
              className={`text-[14px] font-medium whitespace-nowrap ${
                isActive ? "text-white" : "text-black"
              }`}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
